// AI-CONTEXT: See docs/features/subtaken-bij-het-huishouden.md
// Het enige schrijfpad voor een subtaak. Uit SubTasks.jsx gehaald omdat die
// component aan context en Firestore hangt en het document zelf de regels
// draagt die getest moeten worden.

import { isAppointment, SUBTASK_TYPE, GENERIC_SUBTASK_TYPE } from './taskKind'

/**
 * @typedef {object} SubtaskDocInput
 * @property {string} id - Nieuw `ID` voor de subtaak (uuid)
 * @property {string} client - `CompagnyID` van de organisatie
 * @property {{ID?: string, Type?: string, Parent?: string|null, AdressID?: string}|null} [parent] - De taak waar de subtaak onder komt; leeg = nog niet ingepland
 * @property {string} [adressId] - Huishouden uit de URL, als de afspraak er geen draagt
 * @property {string} [userId] - `auth.ID` van wie de subtaak aanmaakt
 * @property {number} [position] - Plek in de lijst
 * @property {string} [title] - Wat er moet gebeuren; het tabblad van het huishouden vraagt dit vooraf, de afspraakbewerker laat het leeg en vult het in de rij in
 */

/**
 * Het Tasks-document voor een nieuwe subtaak.
 *
 * Het soort wordt afgeleid van de OUDER en niet vast op 'huisbezoek' gezet —
 * dat deed het oude schrijfpad, en zo werden subtaken onder een roosterregel
 * of meetmoment (6 in productie) als huisbezoek meegeteld. Onder een
 * huisbezoek, of zonder ouder (nog niet ingepland, aangemaakt vanaf het
 * huishouden), is het een huishoudsubtaak; onder iets anders is het werk
 * zonder huishouden.
 *
 * `Parent` is `''` en nooit `null` als er geen afspraak is: `null` is in
 * Firestore een echte zoekwaarde die de afspraken zelf vindt.
 * AI-CONTEXT: See docs/pitfalls.md#database-firestore-null-is-a-valid-query-value
 *
 * @param {SubtaskDocInput} input
 * @returns {object} Het document zoals het in `Tasks` komt
 */
const buildSubtaskDoc = ({ id, client, parent = null, adressId = '', userId = '', position = 1, title = '' }) => {
    const ouderIsAfspraak = isAppointment(parent)
    const huishoudsubtaak = !parent || ouderIsAfspraak

    return {
        ID: id,
        AdressID: huishoudsubtaak ? (parent?.AdressID || adressId || '') : '',
        Description: '',
        Title: (title || '').trim(),
        Category: '',
        Tags: [],
        CompagnyID: client,
        Compagny: client,
        Position: position,
        Timestamp: null,
        TimestampEnd: null,
        User: userId || '',
        TeamMembers: [],
        Type: huishoudsubtaak ? SUBTASK_TYPE : GENERIC_SUBTASK_TYPE,
        Parent: parent?.ID || '',
        Status: 'toDo',
        EstimateMinutes: null,
        NeedsFollowUp: 'false',
    }
}

export default buildSubtaskDoc
